(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blackbelt-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blackbelt-collection-grid')) {
    class BlackbeltCollectionGrid extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;
          this.grid = this.querySelector('[data-product-grid]');
          this.filters = Array.from(this.querySelectorAll('[data-ram-filter]'));
          this.count = this.querySelector('[data-result-count]');
          this.status = this.querySelector('[data-filter-status]');
          this.empty = this.querySelector('[data-no-matches]');
          this.serverNav = this.querySelector('[data-server-pagination]');
          this.clientNav = this.querySelector('[data-client-pagination]');
          this.pageSize = Number(this.dataset.pageSize) || 48;
          this.sourcePage = Number(this.dataset.currentPage) || 1;
          this.totalPages = Math.max(1, Number(this.dataset.totalPages) || 1);
          this.totalItems = Number(this.dataset.totalItems) || 0;
          this.originalNodes = Array.from(this.grid.childNodes);
          this.pages = new Map([[this.sourcePage, Array.from(this.grid.querySelectorAll('[data-product-id]'))]]);
          this.selection = 0;
          this.onClick = (event) => {
            const filter = event.target.closest('[data-ram-filter]');
            if (filter && this.contains(filter)) {
              event.preventDefault();
              this.selectRam(filter.dataset.ramFilter);
              return;
            }
            const step = event.target.closest('[data-page-step]');
            if (step && this.contains(step) && !step.disabled && this.activeRam !== 'all') {
              event.preventDefault();
              this.currentPage += Number(step.dataset.pageStep);
              this.renderFiltered();
              this.writeURL(this.activeRam, this.currentPage);
              this.grid.focus({ preventScroll: true });
              this.scrollIntoView({ block: 'start' });
            }
          };
          this.onHistory = () => this.restoreURL();
        }
        this.abortController = new AbortController();
        this.addEventListener('click', this.onClick);
        window.addEventListener('popstate', this.onHistory);
        this.querySelector('[data-ram-filters]').hidden = false;
        this.restoreURL();
      }

      disconnectedCallback() {
        this.selection += 1;
        this.abortController?.abort();
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('popstate', this.onHistory);
      }

      restoreURL() {
        const url = new URL(window.location.href);
        const ram = url.searchParams.get('bb_ram');
        const page = Number.parseInt(url.searchParams.get('bb_page'), 10) || 1;
        this.selectRam(['2gb', '4gb'].includes(ram) ? ram : 'all', page, false);
      }

      setPressed(ram) {
        this.filters.forEach((button) => {
          const selected = button.dataset.ramFilter === ram;
          button.classList.toggle('active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      }

      resetAll() {
        this.activeRam = 'all';
        this.currentPage = this.sourcePage;
        this.grid.replaceChildren(...this.originalNodes);
        this.grid.hidden = false;
        this.grid.setAttribute('aria-busy', 'false');
        this.count.textContent = String(this.totalItems);
        this.serverNav.hidden = this.totalPages <= 1;
        this.clientNav.hidden = true;
        this.status.hidden = true;
        this.empty.hidden = true;
        this.setPressed('all');
      }

      async selectRam(ram, page = 1, updateHistory = true) {
        const selection = ++this.selection;
        if (ram === 'all') {
          this.resetAll();
          if (updateHistory) this.writeURL('all');
          return;
        }
        this.setPressed(ram);
        this.status.textContent = this.dataset.loading;
        this.status.hidden = false;
        this.grid.setAttribute('aria-busy', 'true');
        this.grid.hidden = true;
        this.serverNav.hidden = true;
        this.clientNav.hidden = true;
        this.empty.hidden = true;
        try {
          const cards = await this.loadAllCards();
          if (selection !== this.selection || !this.isConnected) return;
          this.activeRam = ram;
          this.filteredCards = cards.filter((card) => card.dataset.ram.split(/\s+/).includes(ram));
          const pageCount = Math.max(1, Math.ceil(this.filteredCards.length / this.pageSize));
          this.currentPage = Math.min(Math.max(1, page), pageCount);
          this.renderFiltered();
          if (updateHistory) this.writeURL(ram, this.currentPage);
        } catch {
          if (selection !== this.selection || !this.isConnected) return;
          this.resetAll();
          this.status.textContent = this.dataset.loadError;
          this.status.hidden = false;
          this.writeURL('all', 1, true);
        }
      }

      async loadAllCards() {
        if (this.allCards) return this.allCards;
        if (this.loadingPromise) return this.loadingPromise;
        this.loadingPromise = this.fetchAllPages();
        try {
          return await this.loadingPromise;
        } finally {
          this.loadingPromise = null;
        }
      }

      async fetchAllPages() {
        const missing = Array.from({ length: this.totalPages }, (_, index) => index + 1)
          .filter((page) => !this.pages.has(page));
        const batch = new AbortController();
        let next = 0;
        const worker = async () => {
          while (next < missing.length) {
            const page = missing[next++];
            const url = new URL(window.location.href);
            url.hash = '';
            url.searchParams.delete('bb_ram');
            url.searchParams.delete('bb_page');
            url.searchParams.delete('sections');
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set(this.dataset.pageParam || 'page', String(page));
            const response = await fetch(url, {
              credentials: 'same-origin',
              signal: AbortSignal.any([this.abortController.signal, batch.signal, AbortSignal.timeout(15000)])
            });
            if (!response.ok) throw new Error('Collection page unavailable');
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = document.getElementById(this.id);
            if (!section || Number(section.dataset.currentPage) !== page || Number(section.dataset.totalItems) !== this.totalItems) {
              throw new Error('Collection changed; reload required');
            }
            const cards = Array.from(section.querySelectorAll('[data-product-id]'));
            const expected = Math.min(this.pageSize, this.totalItems - (page - 1) * this.pageSize);
            if (cards.length !== expected) throw new Error('Incomplete collection page');
            this.pages.set(page, cards);
          }
        };
        try {
          await Promise.all(Array.from({ length: Math.min(2, missing.length) }, worker));
          const cards = Array.from({ length: this.totalPages }, (_, index) => this.pages.get(index + 1)).flat();
          if (cards.length !== this.totalItems || new Set(cards.map((card) => card.dataset.productId)).size !== this.totalItems) {
            throw new Error('Incomplete collection');
          }
          this.allCards = cards;
          return cards;
        } catch (error) {
          batch.abort();
          throw error;
        }
      }

      renderFiltered() {
        const pageCount = Math.max(1, Math.ceil(this.filteredCards.length / this.pageSize));
        const start = (this.currentPage - 1) * this.pageSize;
        this.grid.replaceChildren(...this.filteredCards.slice(start, start + this.pageSize));
        this.grid.hidden = false;
        this.grid.setAttribute('aria-busy', 'false');
        this.count.textContent = String(this.filteredCards.length);
        this.empty.hidden = this.filteredCards.length !== 0;
        this.status.hidden = true;
        this.serverNav.hidden = true;
        this.clientNav.hidden = pageCount <= 1;
        this.clientNav.querySelector('[data-page-step="-1"]').disabled = this.currentPage <= 1;
        this.clientNav.querySelector('[data-page-step="1"]').disabled = this.currentPage >= pageCount;
        this.clientNav.querySelector('[data-page-status]').textContent = this.dataset.pageLabel
          .replace('__CURRENT__', String(this.currentPage)).replace('__TOTAL__', String(pageCount));
        this.setPressed(this.activeRam);
      }

      writeURL(ram, page = 1, replace = false) {
        const url = new URL(window.location.href);
        if (ram === 'all') {
          url.searchParams.delete('bb_ram');
          url.searchParams.delete('bb_page');
        } else {
          url.searchParams.set('bb_ram', ram);
          url.searchParams.set('bb_page', String(page));
        }
        if (url.href !== window.location.href) {
          window.history[replace ? 'replaceState' : 'pushState'](window.history.state, '', url);
        }
      }
    }
    customElements.define('blackbelt-collection-grid', BlackbeltCollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
